import MoveToBank from '../components/moveToBank/index';
import ChannelWalletLedger from '../components/reports/channelWalletLedger';
import SettleToBank from '../components/settleToBank/index';
import SettleToWallet from '../components/settleToWallet';
import fingAepsComponent from '../components/aepsFingpay';
import instantAepsComponent from '../components/aepsInstant';
import MoneyTransfer from '../components/moneyTransfer';
import RegisterMatm from '../components/serviceMATM/registerMatm';
import mobileRecharge from '../components/mobileRecharge';
import uitilityPayment from '../components/uitilityPayment';
import uitilityPayment2 from '../components/uitilityPayment2';
import BharatBillpay from '../components/bharatBillpay';
import BharatBillpayCC from '../components/bharatBillpayCC';

import CommissionRelease from '../components/commissionRelease/index';
import BankSetting from '../components/banksetting';
import PartnerEKYC from '../components/partnerEKYC';
import MyFundRequestReport from '../components/reports/fundRequestPartnerReports';
import PayoutService from '../components/payoutService';
import MatmReport from '../components/reports/matmReport';
import PrepaidReports from '../components/reports/prepaidReports/index';
import AepsHistoryReport from '../components/reports/aepsHistory';
import MoneyTransferHistory from '../components/reports/moneyTransfer';
import FINOMoneyTransferHistory from '../components/reports/finoMoneyTransfer';

import MoveToBankReport from '../components/settleToBank/move_to_bank_report.js';
import EPayoutHistory from '../components/payout/history';
import PayoutHistory2 from '../components/payoutCashFree/history';
import Fino from '../components/fino';
import MoneyTransferFino from '../components/moneyTransferV4/viewCustomer.js';
import InvoicePage from '../components/invoices/dmt_invoice_page.js';
import AEPSInvoicePage from '../components/invoices/aepsInvoicePage.js';
import FundTransferInvoicePage from '../components/invoices/FundTransferInvoicePage.js';
import MerchantCertificate from '../components/MerchantCertificate.js';
import AadharPay from '../components/aadharPay/index.js';
import CashDeposit from '../components/cashDeposit/index.js';
import BBPS_IMWALLET from '../components/bharatBillpayImWallet/index.js';
import CashDepositHistory from '../components/reports/cashDepositHistory.js';
import AadharPayHistory from '../components/reports/aadharPayHistory.js';
import AePSInquiryHistory from '../components/reports/aepsInquiryHistory.js';
import BBPSHistory from '../components/reports/bbpsReport.js';
import LICInsurance from '../components/uitilityPayment2/licInsPayment.js';
import BBPSIP from '../components/bharatBillpayIP/index.js';
import BBPSPayment from '../components/bharatBillpay/BBPSPayment.js';
import FASTagPayment from '../components/fastagBillpayment/index.js';
import CreditCardBillPayment from '../components/creditCardPayment/index.js';
import uitilityPaymentOffline from '../components/uitilityPayment2/utilityPaymentOffline.js';
import UpiAtm from '../components/upiAtm/index.js';
import UpiAtmFing from '../components/upiAtm/fingPayUpiCw.js';

import upiAtmReport from '../components/reports/upiAtmHistory.js';
import FinoDmtImw from '../components/finodmtImw/index.js';
import AirtelDmtImw from '../components/airteldmtImw/index.js';
import FundTransferReport from '../components/reports/fundTransferReport.js'
import MoneyTransferExpress from '../components/moneyTransferExpress/index.js'


import { components } from 'react-select';


const partnerRoutes = [
  { path: '/airtel-dmt-im', component: AirtelDmtImw, allowedRoles: ['partner'] },
  { path: '/money-transfer-express', component: MoneyTransferExpress, allowedRoles: ['partner'] },
  { path: '/fund-transfer-report', component: FundTransferReport, allowedRoles: ['partner'] },
  { path: '/fino-dmt-im', component: FinoDmtImw, allowedRoles: ['partner'] },
  { path: "/upi-atm-report", component: upiAtmReport, allowedRoles: ['partner'] },
  { path: '/upi-atm', component: UpiAtm, allowedRoles: ['partner'] },
  { path: '/upi-atm2', component: UpiAtmFing, allowedRoles: ['partner'] },
  { path: '/credit-card-bill', component: CreditCardBillPayment, allowedRoles: ['partner'] },
  { path: '/fastag-payment', component: FASTagPayment, allowedRoles: ['partner'] },
  { path: '/bbps-payment', component: BBPSPayment, allowedRoles: ['partner'] },
  { path: '/insurance-payment', component: LICInsurance, allowedRoles: ['partner'] },
  { path: '/bbps-history', component: BBPSHistory, allowedRoles: ['partner'] },
  { path: '/bbps-imwallet', component: BBPS_IMWALLET, allowedRoles: ['partner'] },
  { path: '/settle-to-bank', component: SettleToBank, allowedRoles: ['partner'] },
  { path: '/settle-to-wallet', component: SettleToWallet, allowedRoles: ['partner'] },
  { path: '/aeps', component: fingAepsComponent, allowedRoles: ['partner'] },
  { path: '/aadhar-pay', component: AadharPay, allowedRoles: ['partner'] },
  { path: '/cash-deposit', component: CashDeposit, allowedRoles: ['partner'] },
  { path: '/express-aeps', component: instantAepsComponent, allowedRoles: ['partner'] },
  { path: '/money-transfer', component: MoneyTransfer, allowedRoles: ['partner'] },
  { path: '/money-transfer-fino', component: MoneyTransferFino, allowedRoles: ['partner'] },
  { path: '/fino', component: Fino, allowedRoles: ['partner'] },
  { path: '/matm-registration', component: RegisterMatm, allowedRoles: ['partner'] },
  { path: '/mobile-recharge', component: mobileRecharge, allowedRoles: ['partner'] },
  { path: '/uitility-payment-offline', component: uitilityPaymentOffline, allowedRoles: ['partner'] },
  { path: '/uitility-payment', component: uitilityPayment, allowedRoles: ['partner'] },
  { path: '/uitility-payment-2-0', component: uitilityPayment2, allowedRoles: ['partner'] },
  { path: '/bharat-billpay-bbps', component: BharatBillpay, allowedRoles: ['partner'] },
  { path: '/bharat-billpay-cc', component: BharatBillpayCC, allowedRoles: ['partner'] },
  { path: '/bank-setting', component: BankSetting, allowedRoles: ['partner'] },
  { path: '/partner-ekyc', component: PartnerEKYC, allowedRoles: ['partner'] },
  { path: '/myfund-request-report', component: MyFundRequestReport, allowedRoles: ['partner'] },
  { path: '/payout-service', component: PayoutService, allowedRoles: ['partner'] },
  { path: '/commission-release', component: CommissionRelease, allowedRoles: ['partner'] },
  { path: '/matm-report', component: MatmReport, allowedRoles: ['partner'] },
  { path: '/prepaid-reports', component: PrepaidReports, allowedRoles: ['partner'] },
  { path: '/aeps-history-report', component: AepsHistoryReport, allowedRoles: ['partner'] },
  { path: '/cash-deposit-history', component: CashDepositHistory, allowedRoles: ['partner'] },
  { path: '/adhar-pay-history', component: AadharPayHistory, allowedRoles: ['partner'] },
  { path: '/aeps-inquiry-history', component: AePSInquiryHistory, allowedRoles: ['partner'] },
  { path: '/money-transfer-history', component: MoneyTransferHistory, allowedRoles: ['partner'] },
  { path: '/fino-money-transfer-history', component: FINOMoneyTransferHistory, allowedRoles: ['partner'] },
  { path: '/move-to-bank', component: MoveToBank, allowedRoles: ['partner'] },
  { path: '/move-to-bank-report', component: MoveToBankReport, allowedRoles: ['partner'] },
  { path: '/remittance-transfer-report', component: EPayoutHistory, allowedRoles: ['partner'] },
  { path: '/PayoutHistory2', component: PayoutHistory2, allowedRoles: ['partner'] },
  // { path: '/dmtinvoice/:transactionId', component: InvoicePage, allowedRoles: ['partner'] },
  // { path: '/aepsinvoice/:transactionId', component: AEPSInvoicePage, allowedRoles: ['partner'] },
  { path: '/fundtransferinvoice/:transactionId', component: FundTransferInvoicePage, allowedRoles: ['partner'] },
  { path: '/merchant-certificate', component: MerchantCertificate, allowedRoles: ['partner'] },
];

export default partnerRoutes;
